var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseMs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseMS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.04503075,6.50003052 L12.6800085,1.86504728 C13.1066638,1.43839151 13.1066638,0.746647604 12.6800085,0.320052868 C12.2533533,-0.106602905 11.5616712,-0.106602905 11.1350159,0.320052868 L6.49997711,4.95509714 L1.86493828,0.31999183 C1.438283,-0.106663943 0.746600949,-0.106663943 0.319945676,0.31999183 C-0.106648559,0.746647604 -0.106648559,1.43839151 0.319945676,1.86498624 L4.95498451,6.49996948 L0.319945676,11.1350138 C-0.106648559,11.5616695 -0.106648559,12.2534134 0.319945676,12.6800082 C0.746600949,13.1066639 1.438283,13.1066639 1.86493828,12.6800082 L6.49997711,8.04496389 L11.1350159,12.6800082 C11.5616102,13.1066639 12.2533533,13.1066639 12.6800085,12.6800082 C13.1066638,12.2533524 13.1066638,11.5616695 12.6800085,11.1350138 L8.04503075,6.50003052 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compare-membership",
    transform: "translate(-130.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/tick-Copy-8",
    transform: "translate(130.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseMS",
    fill: "#FF0400",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseMs);
export default __webpack_public_path__ + "static/media/icCloseMS.1e82efa12e0e047c042ee16d7ddc635b.svg";
export { ForwardRef as ReactComponent };